<template>
  <div class="choose-experience-banner">
    <div class="choose-experience-banner__text">
      <p class="choose-experience-banner__caption">{{ t('banner.captionBefore') }}</p>
      <p class="choose-experience-banner__count">{{ count }}</p>
      <p class="choose-experience-banner__caption">{{ t('banner.captionAfter', count) }}</p>
    </div>
    <UiButton
      v-view-all-experiences-click
      :text="t('banner.button')"
      :color-mode="UiButtonColorMode.NEUTRAL"
      :variant="UiButtonVariant.PRIMARY"
      :size="UiButtonSize.M"
      :href="href"
    />
  </div>
</template>

<script setup lang="ts">
import { UiButton, UiButtonColorMode, UiButtonSize, UiButtonVariant } from '@experience/core-button-ui';
import { useI18n } from '@experience/i18n';

import { useAnalytics } from '@/shared/lib/analytics';

import ru from '../i18n/ru.json';

defineProps<{
  count: number;
  href: string;
}>();

const { t } = useI18n<{ message: typeof ru }, 'ru'>({
  inheritLocale: true,
  messages: { ru },
});

const { useImmediateClickTracker } = useAnalytics();
// ссылка уводит со страницы, батч не успевает уйти
const vViewAllExperiencesClick = useImmediateClickTracker('sight:view-all-experiences.click');
</script>

<style scoped lang="scss">
.choose-experience-banner {
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  max-width: 248px;
  border-radius: 16px;
}

.choose-experience-banner__caption {
  margin: 0;

  @include typography.base-400-300-regular;
}

.choose-experience-banner__count {
  margin: 4px 0;
  color: var(--alias-color-text-default);

  @include typography.base-1000-950-semi;
}
</style>
